import { Select } from "antd"
import { BaseOptionType } from "antd/lib/select"
import { useEffect, useMemo, useState } from "react"
import { NavLink } from "react-router-dom"
import { RouteService } from "../../../../../../util/services/route"
import { diseasedZone } from "../../../../../../util/varibles/constants"
import { showErrorResponse } from "../../../../../../util/varibles/global"
import { IRoute, TOperation } from "../../../../../../util/varibles/interface"
import styles from "./style.module.scss"

interface IProps {
    startPlaceId?: string
    endPlaceId?: string
    routerId?: string

    onChange(value: Partial<TOperation>): void
}

const SelectRoute: React.FC<IProps> = ({ startPlaceId = "", endPlaceId = "", routerId, onChange }) => {
    const [{ data: routes, loading }, setRoutes] = useState<{ loading: boolean, data: IRoute[] }>({ loading: false, data: [] });

    useEffect(() => {
        if (startPlaceId?.length > 0 && endPlaceId?.length > 0) {
            setRoutes(prev => ({ ...prev, loading: true }));
            RouteService.getByLocation(startPlaceId, endPlaceId)
                .then(rs => {
                    setRoutes({ loading: false, data: rs })
                })
                .catch(error => {
                    setRoutes(prev => ({ ...prev, loading: false }));
                    showErrorResponse("Get routes failure", error)
                });
        }
    }, [startPlaceId, endPlaceId]);

    const opts = useMemo(() => {

        const handleSetDefault = (e: React.MouseEvent, id: string) => {
            e.preventDefault();
            e.stopPropagation();
            setRoutes(prev => ({ ...prev, loading: true }));
            RouteService.setDefault(id)
                .then(() => {
                    setRoutes({ loading: false, data: routes.map(item => ({ ...item, default: item.id === id })) })
                })
                .catch(error => {
                    showErrorResponse('Update failed', error)
                    setRoutes(prev => ({ ...prev, loading: false }));
                })
        }

        const results: BaseOptionType[] = routes.map(item => {
            return {
                key: item.id,
                label: <div className="min-w-[330px]">
                    <div className={styles.route}>
                        <div className={styles.routeName}>
                            <span>{item.name} ({item.distance} nm)</span>
                            <span className="ml-3">{(item.diseases || []).map(sub => {
                                const { name, color } = diseasedZone[sub] || {};
                                return <span style={{ color }} data-lev="disease" key={sub}>{name}</span>
                            })}</span>
                        </div>
                        {item.default
                            ? <div className={styles.default}>Default</div>
                            : <div className={styles.btDefault} onClick={e => handleSetDefault(e, item.id)}>Set default</div>}
                    </div>
                </div>,
                value: item.id
            }
        })
        if ((endPlaceId.length > 0 && !loading)) {
            results.push({
                key: "create",
                disabled: true,
                className: "not-hover-option !cursor-default",
                label: <NavLink className="link" to={`/route?source=${startPlaceId}&destination=${endPlaceId}`}>
                    Create one
                </NavLink>,
                value: "",
            })
        }
        return results
    }, [routes, endPlaceId, loading, startPlaceId])


    return <div className="flex items-center gap-1">
        <span className="text-comment">Route: </span>
        {routes.length === 0
            ? <NavLink className="link" to={`/route?source=${startPlaceId}&destination=${endPlaceId}`}>
                Create one
            </NavLink>
            : <Select
                loading={loading}
                value={loading ? undefined : routerId}
                classNames={{ content: styles.selectRoute }}
                variant={"borderless"}
                popupMatchSelectWidth={false}
                onChange={value => onChange({ router_id: value })}
                options={opts}
            />}
    </div>
}

export default SelectRoute